<ng-select (change)="onSelectElement()" (scrollToEnd)="onGetMoreItems()" (search)="onSearch($event)"
    [(ngModel)]="affection_id" placeholder="Choisissez affection " name="affection_id" id="affection_id"
    [multiple]="false" [closeOnSelect]="true">
    <ng-option *ngFor="let item of items" [value]="item.id">{{item.codification}}==>{{item.libelle}}
    </ng-option>
</ng-select>